import styled from "styled-components";
import { devices } from "@/constants/media";
import { MOBILE_PINNED_VIDEO_HEIGHT_PERCENT } from "@/constants/ui";

export const StyledPinnedPlaceholder = styled.div`
  flex: 1;
  height: 100%;
  @media ${devices.sm} {
    height: ${MOBILE_PINNED_VIDEO_HEIGHT_PERCENT}%;
    min-width: 100%;
  }
`;
